import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {FormControl } from '@angular/forms';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { DatePipe } from '@angular/common';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientFieldsModel } from '../Models/patient_mendatory_fields_config.model';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { SelectionModel } from '@angular/cdk/collections';


export interface DialogData {
  animal: string;
  name: string;
}


@Component({
  selector: 'Searchdialog-modal',
  templateUrl: 'Searchdialog.component.html',
  styleUrls: ['./Searchdialog.component.scss']
})

export class SearchDialogComponent implements OnInit {
  showspinner = false;
  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  public selection: SelectionModel<PatientDetailModel>;
  startdate;
  enddate;
  public sname = "";

  stype: string;
  selecttype: string;
  pname: any;
  PhoneNo: any;
  UHID: any;
  OLDUHID: any;
  patient_mendatory_fields: PatientFieldsModel[] = [];
  tempid: any;
  tempIdshow: boolean = false;
  tempValue: any;
  constructor(public service: VoiceRecognitionService,
    public dialogRef: MatDialogRef<SearchDialogComponent>,
    public opdvisitService: OpdVisitService,
    public datepipe: DatePipe,
    public dashboardService: DashboardService,
    public dialog: MatDialog, public http: HttpClient, public authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public translate: TranslateService, public langservice: LanguageService,) {
   // this.service.init();
    dialogRef.disableClose = true;
    translate.addLangs(['en', 'fr', 'hi']);
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }
    this.selection = new SelectionModel<PatientDetailModel>(true);
  }

  searchList = new FormControl('');
  searchItems: string[] = ['Phone Number', 'Name', 'UHID', 'OLD UHID'];

  //  displayedColumns: string[] = ['Patientid', 'Regdate', 'First_name', 'Last_name',
  //   'Care_of', 'Old_Mrno', 'Adhar_no', 'Address','Mothername','Email','dob','phno','mobno'];


  displayedColumns: string[] = ['TempId', 'Patientid', 'Regdate', 'First_name', 'Last_name',
    'mobno', 'phno', 'adharCardNo','abhaID', 'paddress', 'dob', 'oldMrno', 'careofName', 'motherName',
  ];


  ngOnInit() {

    if (this.data != null && this.data != undefined) {
      this.tempIdshow = this.data[0].TempShow;
      this.tempValue = this.data[0].Type;
    } else {
      this.tempValue = 0;
    }
    //console.log("usertype selected " + this.data.usertype);
    //this.checkusertype (this.data.usertype);
    // this.dataSource.data = this.opdvisitService.patients;     
    this.patientcount = 0;
    this.stype = "S";
    this.selecttype = "PhoneNo";
    this.pname = 0;
    this.PhoneNo = 0;
    this.UHID = 0;
    this.OLDUHID = 0;
    if (this.tempValue == 3) {
      this.selecttype = "TempId";
    }
    this.get_patients_fields_config();
  }
 
  startService() {
    this.service.text = '';
    this.service.start('Patient Search')
  }

  stopService(type) {

    if (type == 0) {
       this.service.stop('Patient Search')
      this.gettop_200byspeachname(this.service.text, 2)
    } else {
       this.service.recognition.stop();
    }

  }
  get_patients_fields_config() {

    this.opdvisitService.getPatientConfig()
      .subscribe(

        data => this.success_config(data), err => this.error_config(err)

      )
  }
  success_config(data) {

    this.patient_mendatory_fields = data;

    //  this.set_default_values();

  }
  error_config(err) {

  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }
  selectType(event) {

    this.selecttype = event;
    console.log(this.selecttype)

  }
  searchType(event) {
    this.stype = event;
  }
  toppatient(sname) {
    this.showspinner = true;
    this.dataSource.data = [];
    this.patientcount = 0;
    if (this.tempValue == 3) {
      if (this.selecttype == "FirstName") {

        this.pname = sname;
        this.PhoneNo = 0;
        this.tempid = 0;

      }
      if (this.selecttype == "PhoneNo") {

        this.PhoneNo = sname;
        this.pname = 0;
        this.tempid = 0;

      }
      if (this.selecttype == "TempId") {
        this.tempid = sname;
        this.pname = 0;
        this.PhoneNo = 0;

      }
      this.opdvisitService.getPateintTempDetails(this.tempid, 0, this.PhoneNo, this.pname, this.stype).subscribe(
        data => this.successtop200Temp(data), err => this.failedtop200(err)
      )
    } else {
      if (this.selecttype == "OLDUHID") {
        this.pname = sname.replace(/\//g, "~");
        this.opdvisitService.getAllPateintSearch(this.stype, this.selecttype,  this.pname, 'ASC').subscribe(
          data => this.successtop200(data), err => this.failedtop200(err)
        )
      }else if(this.selecttype == "UHID"){
        this.pname = sname
        this.opdvisitService.getAllPateintSearch(0, this.selecttype,  this.pname, 'ASC').subscribe(
          data => this.successtop200(data), err => this.failedtop200(err)
        )
      }else{
        this.pname = sname
        this.opdvisitService.getAllPateintSearch(this.stype, this.selecttype,  this.pname, 'ASC').subscribe(
          data => this.successtop200(data), err => this.failedtop200(err)
        )
      }
     
    }

  }

  // }
  // success_top_200pt_patients(data){
  //   this.dataSource.data = data;
  // }
  //   failed_top_200pt_patients(err){

  //   }
  successtop200Temp(data) {

    this.showspinner = false;
    this.opdvisitService.patients = [];
    this.opdvisitService.patients = data.map(item => ({

      fkPcityId: item.fK_PCityId,

      pkRegId: item.fK_RegID,

      paddress: item.patientAddress,

      dob: this.datepipe.transform(item.dob, "yyyy-MM-dd"),
      m_CountryCode: item.m_CountryCode == null ? '+91' : item.m_CountryCode,
      ...item
    }));
    this.dataSource.data = this.opdvisitService.patients;
    this.patientcount = this.opdvisitService.patients.length;
    // alert("api working");
  }
  successtop200(data) {

    this.showspinner = false;
    this.opdvisitService.patients = [];
    this.opdvisitService.patients = data;
    console.log(this.opdvisitService.patients)
    this.dataSource.data = this.opdvisitService.patients;
    this.patientcount = this.opdvisitService.patients.length;
    // alert("api working");
  }

  failedtop200(err) {
    // alert("api failed");
  }
  gettop_200byspeachname(sname, type) {
   
      switch (type) {
        case (2): {
          if (sname.length > 3) {
            this.toppatient(sname);
          } else if (sname.length == 0) {
            this.dataSource.data = [];
            this.patientcount = 0;
          }
          break;
        
        }
    }
  }
  gettop_200byname($event, type) {
   
      var sname: string = $event.target.value;
      switch (type) {
        case (1): {
          if (sname.length > 0) {
            this.toppatient(sname);
          } else if (sname.length == 0) {
            this.dataSource.data = [];
            this.patientcount = 0;
          }
          break;

        }
        case (2): {
          if (($event.keyCode >=48 && $event.keyCode <=57) || ($event.keyCode >=65 && $event.keyCode <=90) || ($event.keyCode >=97 && $event.keyCode <=122) || ($event.code=='Enter')) {
          if (sname.length > 3 || (this.selecttype == "UHID" && sname.length > 0)) {
            this.toppatient(sname);
          } else if (sname.length == 0) {
            this.dataSource.data = [];
            this.patientcount = 0;
          }
          break;
        }
        }
    }
  }





  get_records_between_two_dates() {


    this.showspinner = true;
    this.dataSource.data = [];
    // this.dashboardService.selecteddate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let sdate = this.datepipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datepipe.transform(this.enddate, "yyyy-MM-dd");

    this.opdvisitService.get_pat_sdate_edate(sdate, edate).
      subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
  }

  success_pat_sdate_edate(data) {

    this.showspinner = false;
    this.opdvisitService.patients = [];
    this.opdvisitService.patients = data;
    this.dataSource.data = this.opdvisitService.patients;
    this.patientcount = this.opdvisitService.patients.length;
  }
  failed_pat_sdate_edate(err) {
    this.showspinner = false;
  }


  onNoClick(): void {
    this.dialogRef.close(0);
    this.service.stop('Patient Search')
    this.service.text = '';
  }


  selectpatient(selectedpatient) {
   
    this.stopService(1);
    this.service.text = '';
    if (selectedpatient.pkRegId > 0) {
      this.opdvisitService.patientdetails = {}
      this.opdvisitService.patientdetails.isExpired = selectedpatient.isExpired;
      this.opdvisitService.patientdetails.firstName = selectedpatient.firstName;
      this.opdvisitService.patientdetails.lastName = selectedpatient.lastName;
      this.opdvisitService.patientdetails.pkRegId = selectedpatient.pkRegId;
      this.opdvisitService.patientdetails.fkReferredbyId = selectedpatient.fkReferredbyId;
      this.opdvisitService.patientdetails.fK_DoctorId = selectedpatient.fK_DoctorId;
      //  this.opdvisitService.patientdetails = selectedpatient;
      this.dialogRef.close(selectedpatient.pkRegId);
      if (this.tempValue == 1) {
        this.opdvisitService.getpatientdetails(selectedpatient.pkRegId, 0);
      } else {
        this.opdvisitService.getpatientdetails(selectedpatient.pkRegId);
      }

    } else {
      this.opdvisitService.patientdetails = selectedpatient;
      if (this.tempValue == 3) {
        this.opdvisitService.patientdetails.TempReg_Pk_TranID = selectedpatient.pK_TranID;
        this.opdvisitService.patientdetails.fkPcityId = selectedpatient.fK_PCityId;
        this.opdvisitService.patientdetails.pkRegId = selectedpatient.fK_RegID;
        this.opdvisitService.patientdetails.paddress = selectedpatient.patientAddress;
        this.opdvisitService.patientdetails.dob = this.datepipe.transform(selectedpatient.dob, "yyyy-MM-dd");
        if (this.opdvisitService.patientdetails.m_CountryCode == null) {
          this.opdvisitService.patientdetails.m_CountryCode = '+91';
        }
      }


      this.opdvisitService.get_city_district_state_country(this.opdvisitService.patientdetails.fkPcityId, 1);
      this.dialogRef.close(selectedpatient.pkRegId);
    }




  }
  sortData(sort: Sort) {

    const data = this.dataSource.data.slice();
    console.log(data);
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'pkRegId':
          return this.compare(a.pkRegId, b.pkRegId, isAsc);
        case 'regDate':
          return this.compare(a.regDate, b.regDate, isAsc);

        case 'firstName':
          return this.compare(a.firstName, b.firstName, isAsc);
        case 'lastName':
          return this.compare(a.lastName, b.lastName, isAsc);
        case 'mobileNo':
          return this.compare(a.mobileNo, b.mobileNo, isAsc);
        case 'phoneRes':
          return this.compare(a.phoneRes, b.phoneRes, isAsc);
        case 'adharCardNo':
          return this.compare(a.adharCardNo, b.adharCardNo, isAsc);
          case 'abhaID':
          return this.compare(a.abhaID, b.abhaID, isAsc);
        case 'paddress':
          return this.compare(a.paddress, b.paddress, isAsc);
        case 'dob':
          return this.compare(a.dob, b.dob, isAsc);
        case 'oldMrno':
          return this.compare(a.oldMrno, b.oldMrno, isAsc);
        case 'careofName':
          return this.compare(a.careofName, b.careofName, isAsc);
        case 'motherName':
          return this.compare(a.motherName, b.motherName, isAsc);
        default:
          return 0;
      }
    });
  }
  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}

